import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { RoleSelector } from './RoleSelector/roleselector';
import { RoleSelectorMobile } from './RoleSelectorMobile/roleselectormobile';
import { Login } from './Login/login';
import { AreaBind } from './AreaBind/areabind';
import { Lottery } from './Lottery/lottery';
import { MyGiftList } from './MyGiftList/mygiftlist';
import MyGiftListTpl from './MyGiftList/tplGiftList';
import { CDK } from './CDK/cdk';
import { CheckIn } from './CheckIn/checkin';
import { ProvinceCitySelector } from './CitySelector/cityselector';
import { LotteryBroadcast } from './LotteryBroadcast/broadcast';
import { ShipAddress } from './ShipAddress/shipaddress';
import ShipAddressTpl from './ShipAddress/tpl';
import { miloAlert } from './AlertDialog';
import Dialog from './Dialog';
import { Customize } from './Customize/customize';
import { loadStart, loadStop } from './Loader';
import { DJCPay } from './DJCPay/djcpay';
import { miloCore, FrontMonitor, mobileShare, iosInstallReport, pcShare } from '@tencent/milo-core';
import FormManager from './util/form';

if (!window.No_FrontMonitor_Auto) {
  FrontMonitor.init();
} else {
  // 只监控milo相关的异常数据
  FrontMonitor.initForMilo();
}

var milo = _objectSpread(_objectSpread({
  Login: Login,
  RoleSelector: RoleSelector,
  RoleSelectorMobile: RoleSelectorMobile,
  AreaBind: AreaBind,
  CDK: CDK,
  CheckIn: CheckIn,
  ProvinceCitySelector: ProvinceCitySelector,
  Lottery: Lottery,
  LotteryBroadcast: LotteryBroadcast,
  MyGiftList: MyGiftList,
  ShipAddress: ShipAddress,
  ShipAddressTpl: ShipAddressTpl,
  FormManager: FormManager
}, miloCore), {}, {
  miloAlert: miloAlert,
  mobileShare: mobileShare,
  pcShare: pcShare,
  iosInstallReport: iosInstallReport,
  Customize: Customize,
  loadStart: loadStart,
  loadStop: loadStop,
  Dialog: Dialog,
  DJCPay: DJCPay
}); // console.log(window.milo)


export default milo;
export { Login, RoleSelector, RoleSelectorMobile, AreaBind, CDK, CheckIn, ProvinceCitySelector, Lottery, LotteryBroadcast, MyGiftList, MyGiftListTpl, ShipAddress, ShipAddressTpl, FormManager, miloCore, miloAlert, mobileShare, pcShare, iosInstallReport, Customize, loadStart, loadStop, Dialog, DJCPay };